export const NO_SUBSCRIPTION = 'No Subscription';
export const subscriptionTierMap = {
  basic: 0,
  plus: 1,
  core: 1,
  boost: 2,
  pro: 2,
  vip: 2,
  unlimited: 3
} as const;

export enum TierMap {
  MELIO_ACCOUNTING_CLIENT_CORE = 'Accounting Client Core',
  MELIO_ACCOUNTING_CLIENT_BOOST = 'Accounting Client Boost',
  MELIO_ACCOUNTING_CLIENT_UNLIMITED_ACH = 'Accounting Client Unlimited',
  MELIO_UNLIMITED_FREE_TRIAL = 'Melio Unlimited Free Trial',
  MELIO_BASIC = 'Go',
  MELIO_PLUS = 'Core',
  MELIO_PRO = 'Boost',
  MELIO_UNLIMITED_ACH = 'Unlimited',
  MELIO_VIP = 'VIP',
  MELIO_ACCOUNTING_FIRM = 'Accounting VIP'
}
export const subscriptionTierColorMap = {
  NO_SUBSCRIPTION: 'default',
  MELIO_ACCOUNTING_CLIENT_CORE: 'green',
  MELIO_ACCOUNTING_CLIENT_BOOST: 'purple',
  MELIO_ACCOUNTING_CLIENT_UNLIMITED_ACH: 'pink',
  MELIO_UNLIMITED_FREE_TRIAL: 'red',
  MELIO_BASIC: 'gold',
  MELIO_PLUS: 'green',
  MELIO_PRO: 'purple',
  MELIO_UNLIMITED_ACH: 'pink',
  MELIO_VIP: 'purple',
  MELIO_ACCOUNTING_FIRM: 'purple'
};

export const ACCOUNTING_CLIENT = 'accounting_client';

export const NO_VALUE = 'N/A';
